import { capitalize } from 'lodash';
import { climatic_run_mode_scenario, climatic_set_mode_for_circuit, } from 'console/climatic/actions';
import { HeatingMode } from 'z3k-parser/model/z3k-config/20-heating-mode';
const mode_colors = {
    null: '#ffc107', // Ручной
    20501: '#dd4747', // Комфорт
    20502: '#127fb6', // Эконом
    20503: '#4caf50', // Расписание
    20504: '#9e9e9e', // Выкл
    20505: '#dd4747', // Нагрев ГВС
};
const scenario_colors = {
    20540: mode_colors[20501],
    20541: mode_colors[20502],
    20542: mode_colors[20503],
    20543: mode_colors[20504],
};
export function getClimaticHeatingModesConfig(device_id, z3k_config) {
    const scenarios = z3k_config.scenarios || [];
    const shared_heating_modes = scenarios.map((scenario) => {
        const { id, name, links } = scenario;
        const heating_modes_ids = z3k_config?.commands
            ?.filter((command) => links.includes(command.id))
            .map((command) => command.objectid);
        const heating_mode = HeatingMode.get.one(z3k_config, (mode) => heating_modes_ids?.includes(mode.id) ?? false);
        if (!heating_mode) {
            return null;
        }
        const { id: heating_mode_id, heating_zones } = heating_mode;
        const capitalize_name = capitalize(name);
        const onSelectMode = (heating_circuit_id) => heating_circuit_id
            ? climatic_set_mode_for_circuit(device_id, heating_circuit_id, heating_mode_id)
            : climatic_run_mode_scenario(device_id, id);
        const color = scenario_colors[id];
        const not_configured = heating_zones.length === 0;
        return {
            id: heating_mode_id,
            name: capitalize_name,
            onSelectMode,
            color,
            not_configured,
            heating_zones,
            scenario_id: id,
        };
    });
    return shared_heating_modes;
}
